import gqlClient from '@discover-data/gql/client/client';
import parseErrorMessage from '@discover-lib/parseErrorMessage';
import Button from '@discover-ui/button';
import { graphql } from 'gql.tada';
import { useState } from 'react';

async function fetchUser() {
  const response = await gqlClient({
    query: graphql(`
      query Member($siteId: Int!) {
        Member(siteId: $siteId) {
          id
        }
      }
    `),
    variables: {
      siteId: 1,
    },
  });

  return response.Member;
}

async function refreshToken() {
  const response = await gqlClient({
    query: graphql(`
      mutation refreshMemberToken {
        refreshToken {
          token
          cdnToken
          valid
          status
          message
        }
      }
    `),
    variables: {},
  });

  return response.refreshToken;
}

async function logOut() {
  const response = await gqlClient({
    query: graphql(`
      mutation LogOut {
        logOut {
          status
          message
        }
      }
    `),
    variables: {},
  });

  return response.logOut;
}

export default function AuthTests() {
  const [busy, setBusy] = useState(false);

  return (
    <>
      <Button
        scale="sm"
        loading={busy}
        disabled={busy}
        onClick={async () => {
          try {
            setBusy(true);
            const result = await fetchUser();
            console.log(`Fetch user:\n${JSON.stringify(result, null, 2)}`);
          } catch (error) {
            console.log(`Failed to Fetch user "${parseErrorMessage(error)}"`);
          } finally {
            setBusy(false);
          }
        }}>
        Fetch user
      </Button>
      <Button
        scale="sm"
        loading={busy}
        disabled={busy}
        onClick={async () => {
          try {
            setBusy(true);
            const result = await refreshToken();
            console.log(`Refresh token:\n${JSON.stringify(result, null, 2)}`);
          } catch (error) {
            console.log(`Failed to Refresh token "${parseErrorMessage(error)}"`);
          } finally {
            setBusy(false);
          }
        }}>
        Refresh token
      </Button>
      <Button
        scale="sm"
        loading={busy}
        disabled={busy}
        onClick={async () => {
          try {
            setBusy(true);
            const result = await logOut();
            console.log(`Log out:\n${JSON.stringify(result, null, 2)}`);
          } catch (error) {
            console.log(`Failed to Log out "${parseErrorMessage(error)}"`);
          } finally {
            setBusy(false);
          }
        }}>
        Log out
      </Button>
    </>
  );
}
